import { call, put, takeEvery, all } from 'redux-saga/effects'
import userInformationTypes from './userInformationTypes'
import * as profileActions from './userInformationActions'
import * as initAction from '../initReducer/initActions'
import UserInformationServices from '../../services/ProfileService/UserInformationService'
import notificationActions from '../notifications/notificationActions'

export function * getUserInformation () {
  try {
    const response = yield call(UserInformationServices.getUserInformation)
    yield put(profileActions.getUserInformationSuccess(response))
    yield put(initAction.getAvatarSuccess(response.data.avatar))
  } catch ({ message }) {
    yield put(profileActions.getUserInformationFailure(message))
    yield put(notificationActions.SendToast({ message: 'User information couldn\'t be fetched. Please contact support', type: 'error' }))
  }
}

export function * updateUserInformation ({ payload }) {
  try {
    const userPayload = { ...payload, isNewEmail: undefined }
    const response = yield call(UserInformationServices.updateUserInfo, userPayload)
    yield put(profileActions.updateUserInformationSuccess({
      ...response,
      user: userPayload
    }))
    if (payload.isNewEmail) {
      yield put(notificationActions.SendToast({ message: `An email was sent to ${payload.email} to confirm the email change.`, type: 'info' }))
    } else {
      yield put(notificationActions.SendToast({ message: 'User information has been updated.', type: 'success' }))
    }
  } catch ({ message }) {
    yield put(profileActions.updateUserInformationFailure(message))
    yield put(notificationActions.SendToast({ message: 'User information couldn\'t be updated. Please contact support', type: 'error' }))
  }
}

export function * updatePhotoUserInformation ({ payload }) {
  try {
    const response = yield call(UserInformationServices.updateUserPhoto, payload)
    yield put(profileActions.updatePhotoUserInformationSuccess(response))
    yield put(initAction.getAvatarSuccess(response.data.avatar))
  } catch ({ message }) {
    yield put(profileActions.updatePhotoUserInformationFailure(message))
    yield put(notificationActions.SendToast({ message: 'User photo couldn\'t be updated', type: 'error' }))
  }
}

export function * changeEmailUserInformation ({ payload }) {
  try {
    const response = yield call(UserInformationServices.changeUserEmail, payload.token)
    yield put(profileActions.changeEmailUserInformationSuccess(response))
  } catch ({ message }) {
    yield put(profileActions.changeEmailUserInformationFailure(message))
    yield put(notificationActions.SendToast({ message: 'Email couldn\'t  be changed', type: 'error' }))
  }
}

export function * changePasswordUserInformation ({ payload, callback }) {
  try {
    const response = yield call(UserInformationServices.updateUserPassword, payload)
    yield put(profileActions.changePasswordUserInformationSuccess(response))
    if (callback) yield callback()
    yield put(notificationActions.SendToast({ message: 'Password changed successfully.', type: 'success' }))
  } catch ({ message }) {
    yield put(profileActions.changePasswordUserInformationFailure(message))
    yield put(notificationActions.SendToast({ message: `Password request couldn't  be sent.Please contact support. ${message}`, type: 'error' }))
  }
}

function * onGetUserInformation () {
  yield takeEvery(userInformationTypes.GET_USER_INFORMATION, getUserInformation)
}

function * onUpdateUserInformation () {
  yield takeEvery(userInformationTypes.UPDATE_USER_INFORMATION, updateUserInformation)
}

function * onUpdatePhotoUserInformation () {
  yield takeEvery(userInformationTypes.UPDATE_PHOTO_USER_INFORMATION, updatePhotoUserInformation)
}

function * onChangeEmailUserInformation () {
  yield takeEvery(userInformationTypes.CHANGE_EMAIL_USER_INFORMATION, changeEmailUserInformation)
}

function * onChangePasswordUserInformation () {
  yield takeEvery(userInformationTypes.CHANGE_PASSWORD_USER_INFORMATION, changePasswordUserInformation)
}
export function * profileSaga () {
  yield all([
    call(onGetUserInformation),
    call(onUpdateUserInformation),
    call(onUpdatePhotoUserInformation),
    call(onChangeEmailUserInformation),
    call(onChangePasswordUserInformation)
  ])
}
